/**
 * Forwards the browser BCP-47 language to the backend on location upserts so Google
 * Place Details can use `?languageCode=` on refresh (snake_case per backend contract).
 */

export function getClientLanguageCodeForPlacesUpsert(): string | undefined {
  if (typeof navigator === 'undefined') return undefined;
  const lang = navigator.language?.trim();
  return lang || undefined;
}

/**
 * Sets `language_code` on a location payload when it references a Google place and
 * the client has a language; skips if already set. Safe on server (no-op).
 */
export function appendLanguageCodeForGooglePlacesUpsert(location: Record<string, unknown>): void {
  const lang = getClientLanguageCodeForPlacesUpsert();
  if (!lang) return;
  const gid = location.google_place_id ?? location.googlePlaceId;
  if (typeof gid !== 'string' || !gid.trim()) return;
  if (location.language_code || location.languageCode) return;
  location.language_code = lang;
}
